module.exports = __webpack_public_path__ + "static/1-asset-1-d@2x-6fd85bad02b467e93d5713082f9085e5.png";